import MF1 from '../img/mehrangardh/meh.jpg'
import MF2 from '../img/mehrangardh/meh1.jpg'

import MD from '../img/Md/md.jpg'
import MD1 from '../img/Md/md1.jpg'

import UB from '../img/UB/ub.jpg'
import UB1 from '../img/UB/ub1.jpg'

import KL from '../img/kal/kl.jpg'
import KL1 from '../img/kal/kl1.jpg'

import JS from '../img/js/js.jpg'
import JS1 from '../img/js/js1.jpg'


import GG from '../img/GG/gg1.jpg'
import GG1 from '../img/GG/header.jpg'





const TourData=[
    {  
        title:"MEHRANGARH FORT",
        Image1:MF1,
        Image2:MF2,
        Desc:"Mehrangarh Fort is one of the largest forts in the country. It is located at the top of a 410 feet elevated hill and guarded by huge walls. The fort encloses a museum now which exhibits various belongings of the royals. The palace was built by Rao Jodha in 1459."
    },
    {   
        title:"JASWANT THADA",
        Image1:JS,
        Image2:JS1,
        Desc:"Jaswant Tada is a royal cenotaph built in white marble. It has a small pond and a pretty garden next to it. This structure is just a few minutes downhill walk from the main fort. The memorial was built in the honour of Maharaja Jaswant Singh II by his son Maharaja Sardar Singh in 1899."
    },
    {
        title:"KYALANA LAKE",
        Image1:KL,
        Image2:KL1,
        Desc:"The Kaylana Lake is covering a surface of 84 square km. Constructed in 1872 by Pratap Singh, it serves as the primary resource for drinking water for the citizens of Jodhpur and other neighbouring settlements. A peaceful location, this lake is a must visit for most travellers"
    },
    {
        title:"UMAID BHAWAN",
        Image1:UB,
        Image2:UB1,
        Desc:"Umaid Bhawan Palace is also a major tourist attraction in Jodhpur. In 1944, it was the last of the greatest palaces built in Jodhpur. It is named after the then Maharaja of Jodhpur, Raja Umaid Singh. it is also referred to as the Chittar Palace."
    },
    {
        title:"MANDORE GARDEN",
        Image1:MD,
        Image2:MD1,
        Desc:"Mandore Gardens is located about 10 kilometres from the city of Jodhpur. The garden contains cenotaphs which are built like traditional Hindu temples unlike other cenotaphs. The garden also contains a ruined fort and palace."
    },
    {
        title:"GHANTA GHER",
        Image1:GG,
        Image2:GG1,
        Desc:"The Ghanta Ghar in Jodhpur is a magnificent clock tower in the centre of the city which offers a brilliant panoramic view of the city from the top, surrounded by the busiest and largest marketplace of Jodhpur. The markets and the tower are a must visit for travellers."
    },

]

export default TourData;